import React from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import _ from 'lodash';
import { connect } from 'react-redux';

import ClaimStatus from '../common/ClaimStatus/ClaimStatus';
import OutletDetails from './OutletDetails/OutletDetails';
import InsuredDetails from './InsuredDetails/InsuredDetails';
import ClaimDetails from './ClaimDetails/ClaimDetails';

import Database from '../../Logic/Database';

import './Home.css';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
    this.checkConfirmations = this.checkConfirmations.bind(this);

    this.state = {
      Insured: {},
      Claim: {},
      Outlet: {},
      Vehicle: {},
      Fitment: {},
      alertMessage: null,
    };
  }

  componentDidMount() {
    this.fetchData();
    this.checkConfirmations();
  }

  async fetchData() {
    try {
      const claimData = await Database.FetchAllData();
      const allDataConfirmed = await Database.AllDataConfirmed();

      let alertMessage = null;
      if (!allDataConfirmed) {
        alertMessage = `
          <div class="text-left">
            <p>Welcome to the Autoboys Claims App.</p>
            <p>Here you can keep up to date with all your claim activity.</p>
            <p>Please confirm your <b>Vehicle Detail</b> and your <b>Fitment Address</b> to ensure we service you correctly.</p>
          </div>
        `;
      }

      this.setState({
        Insured: claimData.Insured,
        Claim: claimData.Claim,
        Outlet: claimData.Outlet,
        Vehicle: claimData.Vehicle,
        Fitment: claimData.Fitment,
      });

      if (alertMessage && !sessionStorage.getItem('welcomeShown')) {
        await Swal.fire({
          title: 'Confirm Details',
          html: alertMessage,
          icon: 'info',
          confirmButtonText: 'OK',
        });
        sessionStorage.setItem('welcomeShown', true);
      }
    } catch (error) {
      console.error(error);
      this.props.errorOccured(true);
    }
  }

  checkConfirmations() {
    try {
      Database.FetchVehicle((error, vehicle) => {
        if (!error) {
          this.props.confirmVehicle(vehicle.Confirmed);
          Database.FetchFitment((err1, fitment) => {
            if (!err1) this.props.confirmAddress(fitment.Confirmed);
          });
        }
      });
    } catch (error) {
      console.error(error);
      this.props.errorOccured(true);
    }
  }

  render() {
    const {
      Insured, Claim, Outlet, Fitment,
    } = this.state;

    return (
      <div id="Home" className="row">
        <ClaimStatus />
        <OutletDetails
          BranchName={Outlet.Outlet}
          Csc={Outlet.AssignedAgent}
          ContactNumber={Outlet.ContactNumber}
          fitmentAddress={!_.isUndefined(Fitment) ? Fitment.Address : ''}
        />
        <InsuredDetails
          ClaimNumber={Insured.ClaimNumber}
          InsuredName={Insured.Name}
          InsuredCell={Insured.CellNumber}
        />
        <ClaimDetails
          ClaimId={Claim.ClaimId}
          CustAppId={Claim.CustAppId}
          ClaimType={Claim.ClaimType}
          GlassPosition={Claim.GlassPosition}
          CauseOfLoss={Claim.CauseOfLoss}
          Excess={Claim.Excess}
          ExcessActual={Claim.ExcessActual}
          PaymentStatus={this.props.PaymentStatus}
          PaymentLink={this.props.PaymentLink}
          currentStatus={this.props.currentStatus}
          DateAuthorised={Claim.DateAuthorised}
        />
      </div>
    );
  }
}

Home.propTypes = {
  errorOccured: PropTypes.func.isRequired,
  confirmVehicle: PropTypes.func.isRequired,
  confirmAddress: PropTypes.func.isRequired,
  PaymentStatus: PropTypes.bool.isRequired,
  PaymentLink: PropTypes.string.isRequired,
  currentStatus: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  PaymentStatus: state.paymentStatus,
  PaymentLink: state.paymentLink,
  currentStatus: state.currentStatus,
});

const mapDispatchToProps = (dispatch) => ({
  confirmVehicle: (confirmed) => dispatch({ type: 'CONFIRM_VEHICLE', value: confirmed }),
  confirmAddress: (confirmed) => dispatch({ type: 'CONFIRM_ADDRESS', value: confirmed }),
  errorOccured: (hasError) => dispatch({ type: 'ERROR_OCCURED', value: hasError }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
